import _ from 'underscore';

/**
 * Try to parse error message for video feature,
 * if error code is not localized, it uses error code directly.
 * @param {object} response Error response returned from MT
 * @param {object} i18n Localization service object
 * @returns {Array} Formatted error message list
 */
export const FormatVideoError = (response, i18n) => {
  if (response.status === 200 ||
    !response.responseJSON ||
    !response.responseJSON.value ||
    response.responseJSON.value.length === 0) {
    return [];
  }
  return _.compact(response.responseJSON.value.map(error => error.Code))
    .map(code => i18n.getString(`ImageExperience_Video_Error_${code}`) || /* istanbul ignore next */code);
};

/**
 * Get formatted video errors for video editor
 * if error code is not localized, it uses error code directly.
 * @param {string} scenario Error scenario
 * @param {object} response Error response returned from MT
 * @param {object} i18n Localization service object
 * @returns {Array} Formatted error message list
 */
export const FormatVideoErrorForVideoEditor = (scenario, response, i18n) => {
  /* istanbul ignore next */
  const rawErrorList = FormatVideoError(response, i18n);
  /* istanbul ignore next */
  return rawErrorList.map(message => ({
    scenario,
    message,
    id: _.uniqueId('edit_video_error_'),
  }));
};
